import React from 'react';
import { formatTaskTypeLabel } from '../data/taskTypes';

const TaskItem = ({ task, onDelete, onView }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return '#28a745';
      case 'in_progress': return '#ffc107';
      case 'pending': return '#6c757d';
      default: return '#6c757d';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return '#dc3545';
      case 'medium': return '#ffc107';
      case 'low': return '#28a745';
      default: return '#6c757d';
    }
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'completed': return 'badge badge-success';
      case 'in_progress': return 'badge badge-warning';
      case 'pending': return 'badge badge-info';
      default: return 'badge badge-info';
    }
  };

  const getPriorityBadgeClass = (priority) => {
    switch (priority) {
      case 'high': return 'badge badge-danger';
      case 'medium': return 'badge badge-warning';
      case 'low': return 'badge badge-success';
      default: return 'badge badge-info';
    }
  };

  return (
    <div className="card" style={styles.card} onClick={onView}>
      <div style={styles.header}>
        <h3 style={styles.title}>{task.title}</h3>
        <div style={styles.badges}>
          <span className={getStatusBadgeClass(task.status)}>
            {task.status.replace('_', ' ')}
          </span>
          <span className={getPriorityBadgeClass(task.priority)}>
            {task.priority}
          </span>
        </div>
      </div>

      {task.description && (
        <p style={styles.description}>{task.description}</p>
      )}

      <div style={styles.meta}>
        {task.task_type && (
          <span style={styles.metaItem}>Type: {formatTaskTypeLabel(task.task_type)}</span>
        )}
        {task.location && (
          <span style={styles.metaItem}>📍 {task.location}</span>
        )}
        {task.allocated_to_username && (
          <span style={styles.metaItem}>👤 {task.allocated_to_username}</span>
        )}
        {task.attachment_count > 0 && (
          <span style={styles.metaItem}>📎 {task.attachment_count} file(s)</span>
        )}
        {task.log_count > 0 && (
          <span style={styles.metaItem}>📝 {task.log_count} log(s)</span>
        )}
      </div>

      <div style={styles.footer}>
        <span style={styles.date}>
          Created: {new Date(task.created_at).toLocaleDateString()}
        </span>
        <div style={styles.actions}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onView();
            }}
            className="btn btn-primary"
            style={{ fontSize: '0.875rem', padding: '0.5rem 1rem' }}
          >
            View
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(task.id);
            }}
            className="btn btn-danger"
            style={{ fontSize: '0.875rem', padding: '0.5rem 1rem' }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  card: {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: '1px solid #e5e7eb',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '0.5rem',
  },
  title: {
    margin: 0,
    fontSize: '1.25rem',
    color: '#333',
    flex: 1,
  },
  badges: {
    display: 'flex',
    gap: '0.5rem',
  },
  description: {
    color: '#666',
    marginBottom: '0.5rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  meta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem',
    marginBottom: '0.5rem',
    fontSize: '0.875rem',
    color: '#888',
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '1rem',
    paddingTop: '1rem',
    borderTop: '1px solid #e0e0e0',
  },
  date: {
    fontSize: '0.875rem',
    color: '#888',
  },
  actions: {
    display: 'flex',
    gap: '0.5rem',
  },
};

export default TaskItem;
